import {
  faList,
  faListCheck,
  faListOl,
  faListUl
} from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import type { Editor } from '@tiptap/react'
import { useEditorState } from '@tiptap/react'
import clsx from 'clsx'
import { editorDropdownItem, editorDropdownItemActive } from './EditorInput.css'
import { SplitButtonDropdown } from './SplitButtonDropdown'

export const ListDropdown = ({ editor }: { editor: Editor }) => {
  const editorState = useEditorState({
    editor,
    selector: ({ editor }) => ({
      isBullet: editor.isActive('bulletList'),
      isOrdered: editor.isActive('orderedList'),
      isTask: editor.isActive('taskList')
    })
  })

  const isActive =
    editorState.isBullet || editorState.isOrdered || editorState.isTask

  return (
    <SplitButtonDropdown
      isActive={isActive}
      icon={<FontAwesomeIcon icon={faList} />}
      onMainClick={() => editor.chain().focus().toggleBulletList().run()}
    >
      <button
        type="button"
        className={clsx(
          editorDropdownItem,
          editorState.isBullet && editorDropdownItemActive
        )}
        onClick={() => editor.chain().focus().toggleBulletList().run()}
      >
        <FontAwesomeIcon icon={faListUl} />
        Liste à puces
      </button>
      <button
        type="button"
        className={clsx(
          editorDropdownItem,
          editorState.isOrdered && editorDropdownItemActive
        )}
        onClick={() => editor.chain().focus().toggleOrderedList().run()}
      >
        <FontAwesomeIcon icon={faListOl} />
        Liste numérotée
      </button>
      <button
        type="button"
        className={clsx(
          editorDropdownItem,
          editorState.isTask && editorDropdownItemActive
        )}
        onClick={() => editor.chain().focus().toggleTaskList().run()}
      >
        <FontAwesomeIcon icon={faListCheck} />
        Liste de tâches
      </button>
    </SplitButtonDropdown>
  )
}
